import Axios from "axios";
import { reactLocalStorage } from "reactjs-localstorage";
import util from "util";
import Const from "../const";
global.language = "ko";
global.lanList = ["ko", "en", "ja", "zh"];

const serverUrl = Const.serverPort === 443 
  ? Const.serverProtocol + "://" + Const.serverIp
  : Const.serverProtocol + "://" + Const.serverIp + ":" + Const.serverPort;

const makeUrl = (url, params) => {
  var result = serverUrl + url;
  if (params === null) return result;
  params.forEach((param) => {
    result = util.format(result, param);
  });
  return result;
};

const httpExec = (method, url, data) => {
  return new Promise((resolve, reject) => {
    Axios({
      method: method,
      url: url,
      data: data,
      withCredentials: true,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        console.log(JSON.stringify(error, null, 4));
        if (error.message.includes("401")) {
          alert("로그인이 만료되었습니다. 다시 로그인해주세요");
          reactLocalStorage.remove("adminUser");
          global.location.href = "/";
        }
        reject(error);
      });
  });
};

const httpGet = (url, params, data) => {
  console.log(makeUrl(url, params));
  return httpExec("GET", makeUrl(url, params), data);
};

const httpPut = (url, params, data) => {
  return httpExec("PUT", makeUrl(url, params), data);
};

const httpPost = (url, params, data) => {
  return httpExec("POST", makeUrl(url, params), data);
};

const httpDelete = (url, params, data) => {
  return httpExec("DELETE", makeUrl(url, params), data);
};

const httpDownload = (url, params, data) => {
  return new Promise((resolve, reject) => {
    Axios({
      method: "GET",
      url: makeUrl(url, params),
      data: data,
      withCredentials: true,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      responseType: "arraybuffer",
    })
      .then((response) => {
        var blob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        resolve(blob);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const imageUrl = (idx) => {
  console.log(JSON.stringify(idx));
  return (
    Const.serverProtocol +
    "://" +
    Const.serverIp +
    ":" +
    Const.serverPort +
    Const.serverContext +
    "/file/" +
    idx
  );
};

const httpUrl = {
  login: "/login",
  logout: "/logout",

  //confirm pw
  checkPw: '/user/checkPw',
  changePw: '/user/changePw',

  // transaction
  depositRequestList:'/transaction/depositRequest/list?endDate=%s&pageNum=%s&pageSize=%s&searchText=%s&searchType=%s&startDate=%s',
  depositRequestListExcel:'/transaction/depositRequest/excelList?endDate=%s&searchText=%s&searchType=%s&startDate=%s',
  transferRequestList:'/transaction/transferRequest/list?endDate=%s&pageNum=%s&pageSize=%s&searchText=%s&searchType=%s&startDate=%s',
  transferRequestListExcel:'/transaction/transferRequest/excelList?endDate=%s&searchText=%s&searchType=%s&startDate=%s',
  transferLogList: '/transaction/transferLog/list?searchText=%s&searchType=%s&startDate=%s&endDate=%s&pageNum=%s&pageSize=%s&transferType=%s&statusType=%s',
  transferLogExcelList: '/transaction/transferLog/excelList?searchText=%s&searchType=%s&startDate=%s&endDate=%s&pageNum=%s&pageSize=%s&transferType=%s&statusType=%s',
  signalTransactionList: '/transaction/signalTransaction/list?searchText=%s&searchType=%s&startDate=%s&endDate=%s&pageNum=%s&pageSize=%s&processedType=%s',
  signalTransactionExcelList: '/transaction/signalTransaction/excelList?searchText=%s&searchType=%s&startDate=%s&endDate=%s&processedType=%s',

  //wallet
  getBlockchainList: "/blockchain/list",
  getMergeList: "/serverWallet/merge/list?pageSize=%s&pageNum=%s&coinType=%s&fee=%s",
  walletMerge: "/serverWallet/merge",
  getMergeLogList:
    "/serverWallet/merge/list/mergeLog?pageSize=%s&pageNum=%s&logType=%s&coinType=%s&searchText=%s&startDate=%s&endDate=%s",
    
  getEthLogList:
    "/serverWallet/merge/list/ethFeeLog?pageSize=%s&pageNum=%s&logType=%s&coinType=%s&searchText=%s&startDate=%s&endDate=%s",
  downLoadEthLogList:
    "/serverWallet/merge/list/ethFeeLog/excel?pageSize=%s&pageNum=%s&logType=%s&coinType=%s&searchText=%s&startDate=%s&endDate=%s",

  //otp
  getotpKey: '/otp/get/key',
  setOtpVerify: '/otp/verified?key=%s',
  otpRemove: '/otp/remove?password=%s',
  checkOtpKey: '/otp/check/key?key=%s',

  //serverWallet
  serverWalletInfo:'/serverWallet/info?coinType=%s',

  //log
  getLoginLog:'/log/adminLogin?endDate=%s&pageNum=%s&pageSize=%s&startDate=%s',

  //user
  getUserList:'/user/list?endDate=%s&pageNum=%s&pageSize=%s&searchText=%s&searchType=%s&startDate=%s',

  //admin
  getAdminInfo:'/admin/info',
  updateAdminInfo:'/admin/update',
  changeAdminPW:'/admin/changePassword',

  //company
  getCompanyInfo: (idx) => `/company/info/${idx}`,
  updateCompanyInfo: '/company/update',

  withdrawSingle: '/serverWallet/withdraw/single',
};

const imageType = ["image/jpeg", "image/png", "image/bmp"];

export {
  serverUrl,
  httpExec,
  makeUrl,
  httpGet,
  httpUrl,
  httpPut,
  httpPost,
  httpDelete,
  httpDownload,
  imageType,
  imageUrl,
};
